import { render, staticRenderFns } from "./sensitiveView.vue?vue&type=template&id=716011fc&scoped=true"
import script from "./sensitiveView.vue?vue&type=script&lang=js"
export * from "./sensitiveView.vue?vue&type=script&lang=js"
import style0 from "./sensitiveView.vue?vue&type=style&index=0&id=716011fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716011fc",
  null
  
)

export default component.exports